import React, {useContext, useState, useEffect, useRef} from 'react'
import { FloatButton, Tooltip } from "antd";
import { Help, Chat } from "@mui/icons-material";
import { UserContext } from "@context/UserContext";

const FloatingHelp = ({ globalShortcuts }) => {
    const { user } = useContext(UserContext);
    const buttonRef = useRef();

    const handleZendeskButtonClick = () => {
        openZendeskWidget('Help widget');
    }

    const handleHelpButtonClick = () => {
        loadBrandHelp('Help');
    }

    useEffect(() => {
        if(buttonRef?.current) {
            const describedbyAttributes = buttonRef.current.querySelectorAll('[aria-describedby^=":"]');
            describedbyAttributes?.forEach((el) => {
                el.removeAttribute('aria-describedby');
            });
        }
    }, [buttonRef?.current]);

    if(globalShortcuts.some(shortcut => shortcut.name === 'Help widget' && user.subscriberType !== 'STUDENT')){
        return(
            <FloatButton
                id="edjin-zendesk-widget"
                ref={buttonRef}
                icon={<Chat fontSize={"inherit"} />}
                onClick={() => handleZendeskButtonClick()}
                tooltip={"Access support"}
                aria-label={"Access support"}
                type={"primary"}
                style={{bottom: 'var(--ant-margin-md)', width: "50px", height: "50px", border: "4px solid rgba(255, 255,255, 0.6)"}}
            />
        )
    } else {
        return(
            <FloatButton
                id="edjin-help-link"
                ref={buttonRef}
                icon={<Help fontSize={"inherit"} />}
                onClick={() => handleHelpButtonClick()}
                tooltip={"Support"}
                aria-label={"Support"}
                type={"primary"}
                style={{bottom: 'var(--ant-margin-md)', width: "50px", height: "50px", border: "5px solid rgba(255, 255,255, 0.6)"}}
            />
        )
    }
}

export default FloatingHelp;